export { default as COLOR } from "../color.json";

export const LINKS = {
  GITHUB: "https://www.github.com/aniket-hue",
  LINKED_IN: "https://www.linkedin.com/in/aniket98/",
  RESUME: "https://rxresu.me/aniketsaxena1998/aniket-saxena-sse-2-yoe",
};
